import MD5 from 'crypto-js/md5';
import JSEncrypt from 'jsencrypt';

export const encryptPassword = (password: string, rsaKey: string) => {
  const crypt = new JSEncrypt();
  crypt.setPublicKey(rsaKey);
  const md5 = MD5(password).toString();
  const code = crypt.encrypt(md5);
  return code || '';
};

export const DEFAULT_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnmRk4sH+i2hjfcfFm9iq
JT/iL4s0faCRiQ1OKHNO3Bwt+WQE3TP4JomqDt39OG46DQrnrUQqR7eqHMpzbe4U
UG3dRaiDLUeuj/fII+/odMYxhnk8mys4fkVYODwQruYJBtWOa5GFGgu7VVNRd4HX
EOStq3aWxEDXXQlDxHFqWcu+FZ1yxBX9vBkyFKTdPnhExZyklYMXmVQG4bzD57sj
ne1xCvIbYRXh49QIwZHH8G5IW2UGIh5Cn5KBedsxRFQRKC9fWRER+pI7RFgquwu9
L+xCoSEI9j6e5gRGQkzmD9uWLXF60eddlH4h2+U7yYhokpS4B66imNRbN/AqnymC
uQIDAQAB
-----END PUBLIC KEY-----`;

export const encryptCode = (code: string, rsaKey: string) => {
  const crypt = new JSEncrypt();
  crypt.setPublicKey(rsaKey);
  const codeStr = crypt.encrypt(code);
  return codeStr || '';
};
